import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_THERMAL_STABILITY_TEST_REQUEST,
  CREATE_THERMAL_STABILITY_TEST_SUCCESS,
  CREATE_THERMAL_STABILITY_TEST_FAILURE,

  GET_THERMAL_STABILITY_TEST_REQUEST,
  GET_THERMAL_STABILITY_TEST_SUCCESS,
  GET_THERMAL_STABILITY_TEST_FAILURE,

  EDIT_THERMAL_STABILITY_TEST_REQUEST,
  EDIT_THERMAL_STABILITY_TEST_SUCCESS,
  EDIT_THERMAL_STABILITY_TEST_FAILURE,
  DELETE_THERMAL_STABILITY_TEST_REQUEST,
  DELETE_THERMAL_STABILITY_TEST_SUCCESS,
  DELETE_THERMAL_STABILITY_TEST_FAILURE,
  UPLOADCSV_THERMAL_STABILITY_REQUEST,
  UPLOADCSV_THERMAL_STABILITY_SUCCESS,
  UPLOADCSV_THERMAL_STABILITY_FAILURE,

} from "./thermalStabilityTestATypes";


let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;


const createThermalStabilityTestRequest = () => ({
  type: CREATE_THERMAL_STABILITY_TEST_REQUEST
});

const createThermalStabilityTestSuccess = (payload) => ({
  type: CREATE_THERMAL_STABILITY_TEST_SUCCESS,
  payload,
});

const createThermalStabilityTestFailure = (error) => ({
  type: CREATE_THERMAL_STABILITY_TEST_FAILURE,
  payload: error,
});

const createThermalStabilityTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createThermalStabilityTestRequest());

    let url = `${baseUrl}/dpp/thermal_stability/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createThermalStabilityTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createThermalStabilityTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getThermalStabilityTestRequest = () => ({
  type: GET_THERMAL_STABILITY_TEST_REQUEST,
});

const getThermalStabilityTestSuccess = (payload) => ({
  type: GET_THERMAL_STABILITY_TEST_SUCCESS,
  payload,
});

const getThermalStabilityTestFailure = (error) => ({
  type: GET_THERMAL_STABILITY_TEST_FAILURE,
  payload: error,
});


const getThermalStabilityTest = (dppId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getThermalStabilityTestRequest());
    let url = dppId
      ? `${baseUrl}/dpp/thermal_stability/get_dpp?dppId=${dppId}`
      : `${baseUrl}/dpp/thermal_stability/get_all`;

    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getThermalStabilityTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getThermalStabilityTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editThermalStabilityTestRequest = () => ({
  type: EDIT_THERMAL_STABILITY_TEST_REQUEST,
});

const editThermalStabilityTestSuccess = (payload) => ({
  type: EDIT_THERMAL_STABILITY_TEST_SUCCESS,
  payload,
});

const editThermalStabilityTestFailure = (error) => ({
  type: EDIT_THERMAL_STABILITY_TEST_FAILURE,
  payload: error,
});

const editThermalStabilityTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editThermalStabilityTestRequest());

    let url = `${baseUrl}/dpp/thermal_stability/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editThermalStabilityTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editThermalStabilityTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const deleteThermalStabilityTestRequest = () => ({
  type: DELETE_THERMAL_STABILITY_TEST_REQUEST,
});

const deleteThermalStabilityTestSuccess = (payload) => ({
  type: DELETE_THERMAL_STABILITY_TEST_SUCCESS,
  payload,
});

const deleteThermalStabilityTestFailure = (error) => ({
  type: DELETE_THERMAL_STABILITY_TEST_FAILURE,
  payload: error,
});

const deleteThermalStabilityTest = (testId, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };

  return (dispatch) => {
    dispatch(deleteThermalStabilityTestRequest());

    let url = `${baseUrl}/dpp/thermal_stability/delete/${testId}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteThermalStabilityTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteThermalStabilityTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForThermalStabilityRequest = () => ({
  type: UPLOADCSV_THERMAL_STABILITY_REQUEST,
});

const uploadCsvForThermalStabilitySuccess = (payload) => ({
  type: UPLOADCSV_THERMAL_STABILITY_SUCCESS,
  payload: payload,
});

const uploadCsvForThermalStabilityFailure = (error) => ({
  type: UPLOADCSV_THERMAL_STABILITY_FAILURE,
  payload: error,
});

const uploadCsvForThermalStability = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForThermalStabilityRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_tests/upload?testType=thermalStability`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForThermalStabilitySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForThermalStabilityFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createThermalStabilityTest,
  getThermalStabilityTest,
  editThermalStabilityTest,
  deleteThermalStabilityTest,
  uploadCsvForThermalStability,
}